function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon/button/unpair/white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-1",
  points: "3.75 6 2.25 6 0 3.75 3.75 0 6.75 3"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  points: "8.25 6 9.75 6 12 8.25 8.25 12 5.25 9"
})), /*#__PURE__*/React.createElement("line", {
  x1: 8.25,
  y1: 3,
  x2: 8.25,
  y2: 1.5,
  id: "Stroke-6"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.75,
  y1: 3,
  x2: 10.5,
  y2: 2.25,
  id: "Stroke-7"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.75,
  y1: 4.5,
  x2: 11.25,
  y2: 4.5,
  id: "Stroke-8"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.25,
  y1: 7.5,
  x2: 0.75,
  y2: 7.5,
  id: "Stroke-9"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.25,
  y1: 9,
  x2: 1.5,
  y2: 9.75,
  id: "Stroke-10"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.75,
  y1: 9,
  x2: 3.75,
  y2: 10.5,
  id: "Stroke-11"
})));

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.f97c75d2.svg";
export { ForwardRef as ReactComponent };